'use client';

import { useCallback, useEffect } from 'react';

import { usePathname } from 'next/navigation';

import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { getPersistentId } from '@/modules/activityTracker/helpers';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useCurrentRoute } from '@/modules/activityTracker/useCurrentRoute';
import { createBranchBannerActionATPayload } from '@/modules/branch/helpers';
import { useBranch } from '@/modules/externalTracking/useBranch';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function InitBranch() {
  const { getBranch } = useBranch();
  const [, user] = useCurrentUser();
  const { sendActivityTrackerEvent } = useActivityTracker({ userId: user?.id });
  const urlPath = usePathname();
  const page = useCurrentRoute();

  const shouldTrack = useCallback(
    () => window.navigator.doNotTrack !== '1',
    []
  );

  useEffect(() => {
    async function initBranchBannerTracking() {
      if (!shouldTrack()) {
        return;
      }

      const branch = await getBranch();

      if (!branch) {
        return;
      }
      const persistentId = await getPersistentId();
      branch.setBranchViewData({
        data: { referrerPersistentIdentifier: persistentId },
      });
      branch.addListener('didShowJourney', (_, data) => {
        sendActivityTrackerEvent(
          ActivityTrackerEventType.BRANCH_BANNER_ACTION,
          createBranchBannerActionATPayload('didShowJourney', data)
        );
      });
      branch.addListener('didClickJourneyCTA', (_, data) => {
        sendActivityTrackerEvent(
          ActivityTrackerEventType.BRANCH_BANNER_ACTION,
          createBranchBannerActionATPayload('didClickJourneyCTA', data)
        );
        sendActivityTrackerEvent(ActivityTrackerEventType.APP_DOWNLOAD_ACTION, {
          page,
          urlPath,
          ctaId: 'branch_banner',
          schemaVersion: '1.0',
        });
      });
      branch.addListener('didClickJourneyClose', (_, data) => {
        sendActivityTrackerEvent(
          ActivityTrackerEventType.BRANCH_BANNER_ACTION,
          createBranchBannerActionATPayload('didClickJourneyClose', data)
        );
      });
    }

    initBranchBannerTracking();
  }, [shouldTrack]);

  return null;
}
